import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/SOFAR/SOFAR/app/learn/[id]/CoursePageClient.jsx");
